/**
 * @generated SignedSource<<7145b0e338da46b247d08cbe59b1ee4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CANT_DELETE_TASK_REASON = "HAS_LOCKED_TIME" | "HAS_INVOICED_TIME" | "HAS_TIME_REGS" | "HAS_OTHER_PEOPLES_TIME_REGS" | "JIRA" | "GITHUB" | "UNIT4" | "NO_USER_TYPE" | "BLOCKED_BY_SUBTASK" | "NO_PERMISSION" | "%future added value";
export type CreateTaskSetInput = {
  globalProjectId: string;
  frequency: string;
  intervalLength?: number | null;
  weekdays?: ReadonlyArray<string> | null;
  monthlyWeekday?: string | null;
  monthlyMode?: string | null;
  dayOfMonth?: number | null;
  weekOrdinal?: number | null;
  seedDate: string;
  boundType: string;
  boundCount?: number | null;
  boundEndDate?: string | null;
  setName: string;
  instanceName: string;
  description?: string | null;
  estimateForecast?: number | null;
  globalRoleId?: string | null;
  globalAssignedPersonId?: string | null;
  globalAssignedPersonIds?: ReadonlyArray<string | null> | null;
  globalPhaseId?: string | null;
  globalDeliverableId?: string | null;
  globalStatusColumnId?: string | null;
  globalLabelIds?: ReadonlyArray<string | null> | null;
  billable?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createTaskSetMutation$variables = {
  input: CreateTaskSetInput;
};
export type createTaskSetMutation$data = {
  readonly createTaskSet: {
    readonly taskSet: {
      readonly id: string;
      readonly name: string | null;
      readonly frequency: string | null;
      readonly intervalLength: number | null;
      readonly weekdays: ReadonlyArray<string> | null;
      readonly monthlyWeekday: string | null;
      readonly monthlyMode: string | null;
      readonly seedDate: string | null;
      readonly boundType: string | null;
      readonly boundCount: number | null;
      readonly boundEndDate: string | null;
      readonly materialisedTo: string | null;
      readonly instanceCount: number | null;
    } | null;
    readonly project: {
      readonly id: string;
    } | null;
    readonly tasks: ReadonlyArray<{
      readonly id: string;
      readonly approved: boolean | null;
      readonly assignedPersons: ReadonlyArray<{
        readonly id: string;
      } | null> | null;
      readonly billable: boolean | null;
      readonly blocked: boolean | null;
      readonly bug: boolean | null;
      readonly companyTaskId: number | null;
      readonly startDay: number | null;
      readonly startMonth: number | null;
      readonly startYear: number | null;
      readonly deadlineDay: number | null;
      readonly deadlineMonth: number | null;
      readonly deadlineYear: number | null;
      readonly done: boolean | null;
      readonly estimateForecast: number | null;
      readonly estimateForecastMinutes: number | null;
      readonly highPriority: boolean | null;
      readonly progress: number | null;
      readonly userCanDeleteTask: boolean | null;
      readonly userCantDeleteTaskReason: CANT_DELETE_TASK_REASON | null;
      readonly timeLeft: number | null;
      readonly timeLeftMinutesWithoutFutureTimeRegs: number | null;
      readonly name: string | null;
      readonly project: {
        readonly id: string;
        readonly completion: number | null;
        readonly remaining: number | null;
        readonly forecast: number | null;
      } | null;
      readonly role: {
        readonly id: string;
      } | null;
      readonly phase: {
        readonly id: string;
      } | null;
      readonly statusColumnV2: {
        readonly id: string;
      } | null;
    } | null> | null;
  } | null;
};
export type createTaskSetMutation = {
  variables: createTaskSetMutation$variables;
  response: createTaskSetMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v1/*: any*/)
],
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateTaskSetPayload",
    "kind": "LinkedField",
    "name": "createTaskSet",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TaskSet",
        "kind": "LinkedField",
        "name": "taskSet",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "frequency",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "intervalLength",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "weekdays",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "monthlyWeekday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "monthlyMode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "seedDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "boundType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "boundCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "boundEndDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "materialisedTo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "instanceCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectType",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": (v3/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "tasks",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "approved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "assignedPersons",
            "plural": true,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "billable",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "blocked",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyTaskId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deadlineDay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deadlineMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deadlineYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "done",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimateForecast",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimateForecastMinutes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "highPriority",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "progress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userCanDeleteTask",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userCantDeleteTaskReason",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeLeft",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeLeftMinutesWithoutFutureTimeRegs",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "completion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "remaining",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "forecast",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Role",
            "kind": "LinkedField",
            "name": "role",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PhaseType",
            "kind": "LinkedField",
            "name": "phase",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StatusColumnV2",
            "kind": "LinkedField",
            "name": "statusColumnV2",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createTaskSetMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createTaskSetMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "539edb062f6f6b8bd01f20787b584006",
    "id": null,
    "metadata": {},
    "name": "createTaskSetMutation",
    "operationKind": "mutation",
    "text": "mutation createTaskSetMutation(\n  $input: CreateTaskSetInput!\n) {\n  createTaskSet(input: $input) {\n    taskSet {\n      id\n      name\n      frequency\n      intervalLength\n      weekdays\n      monthlyWeekday\n      monthlyMode\n      seedDate\n      boundType\n      boundCount\n      boundEndDate\n      materialisedTo\n      instanceCount\n    }\n    project {\n      id\n    }\n    tasks {\n      id\n      approved\n      assignedPersons {\n        id\n      }\n      billable\n      blocked\n      bug\n      companyTaskId\n      startDay\n      startMonth\n      startYear\n      deadlineDay\n      deadlineMonth\n      deadlineYear\n      done\n      estimateForecast\n      estimateForecastMinutes\n      highPriority\n      progress\n      userCanDeleteTask\n      userCantDeleteTaskReason\n      timeLeft\n      timeLeftMinutesWithoutFutureTimeRegs\n      name\n      project {\n        id\n        completion\n        remaining\n        forecast\n      }\n      role {\n        id\n      }\n      phase {\n        id\n      }\n      statusColumnV2 {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "88dc52a0e7590ee269282a14e99ab2a7";

export default node;
